import { __extends } from 'tslib';
import classNames from 'classnames';
import * as React from 'react';
import styles from './Sticky.module.scss.js';

var StickyHeader = (function (_super) {
    __extends(StickyHeader, _super);
    function StickyHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.container = null;
        _this.onScroll = function (e) {
            if (_this.container) {
                var translateY = _this.container.scrollTop;
                if (_this.sticky) {
                    _this.sticky.style.transform = "translate(0, " + translateY + "px)";
                    if (translateY === 0) {
                        _this.sticky.classList.remove(styles.headerWrapperActive);
                    }
                    else {
                        _this.sticky.classList.add(styles.headerWrapperActive);
                    }
                }
            }
        };
        return _this;
    }
    StickyHeader.prototype.componentDidMount = function () {
        this.container = document.getElementById(this.props.containerId);
        if (this.container) {
            this.container.addEventListener('scroll', this.onScroll);
        }
    };
    StickyHeader.prototype.render = function () {
        var _this = this;
        var _a;
        return (React.createElement("div", { className: classNames(styles.headerWrapper, (_a = this.props) === null || _a === void 0 ? void 0 : _a.className), ref: function (r) {
                if (r) {
                    _this.sticky = r;
                }
            } }, this.props.children));
    };
    return StickyHeader;
}(React.Component));

export { StickyHeader as default };
//# sourceMappingURL=StickyHeader.js.map
